import {Alert, Col} from "reactstrap";
import React, { useEffect, useState } from "react";
import {connect} from "react-redux";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import { SpinnerConstructor } from "../../../../../shared/components";

const SeletorRepositorios = React.lazy( () => import("../../../components/Home/SeletorRepositorios"))
const SeletorProdutosTarget = React.lazy( () => import("../../../components/Home/SeletorProdutosTarget"))

/**
 *
 * @param consultaRx
 * @param guiasPesquisaRx
 * @returns {JSX.Element}
 * @constructor
 */
const SemConteudo = ({ consultaRx, guiasPesquisaRx }) => {
    const { pesquisa, base } = consultaRx;
    const location = useLocation();
    const history = useHistory();
    const { t } = useTranslation();
    const [timeToBreathe, setTimeToBreathe] = useState(false)

    const  { guia = null } = useParams();
    const guiaSelecionada = guia || (guiasPesquisaRx && guiasPesquisaRx?.length && guiasPesquisaRx.find(guia => guia.ordem === 0)?.codigo);

    useEffect(()=>{
        setTimeToBreathe(true)
        setTimeout(() => {
            setTimeToBreathe(false)
        }, 7000);
    },[alerta])

    const alerta = (
        <div className="mt-3 container">
            <Alert color="warning" className="p-3">
                <h4 className="alert-heading">
                    {t('NenhumResultadoEncontrado')}
                </h4>
                <p className="mb-2">
                    {t('SuaPesquisaNenhumRegistro')}
                </p>
                <p className="mb-0 s13">
                    {t('SuaPesquisaNenhumRegistro2')}
                </p>
            </Alert>
        </div>
    );

    if(pesquisa === 'pesquisa_geral'){
        return (
            <>
                <Col
                    md="3"
                    xs="12"
                    className="b-w1 b-tema50 pt-3 pl-2 pr-2"
                >
                    <SeletorRepositorios
                        guiaSelecionada={guiaSelecionada}
                        location={location}
                        history={history}
                    />
                    {(base === 'target_gedweb') && (
                        <SeletorProdutosTarget
                            guiaSelecionada={guiaSelecionada}
                            location={location}
                            history={history}
                        />
                    ) || <div/>}
                </Col>
                <Col
                    xs="12"
                    md="9"
                    className="pr-0 border-left b-w1 b-tema50"
                >
                    { timeToBreathe && (
                        <div className="mt-3 container d-flex justify-content-center align-items-center">
                            <SpinnerConstructor
                                visible
                                showLabel
                                height={50}
                                width={50}
                                className="apergamum"
                            >
                            </SpinnerConstructor>
                        </div>
                       ) || alerta
                    }
                </Col>
            </>
        )
    }

    return  <Col xs="12" md="12" className="pr-0 b-tema50">{alerta}</Col>
}

const mapStateToProps = state => ({
    guiasPesquisaRx: state.pageConfig.guiasPesquisa,
    consultaRx : state.pesquisa.consulta,
});


export default connect(mapStateToProps)(SemConteudo);
